import FlexContainer from 'global_elements/Layouts/FlexContainer';
import { useContext, useState, useEffect, JSX } from 'react';
import { AnyRoute } from 'constants/routes';
import { AlignVariant, DisplayVariant, JustifyVariant } from 'global_elements/Layouts/FlexContainer/variants';
import Paragraph from 'global_elements/Text/Paragraph';
import { FontColors, FontSizes } from 'global_elements/Text/variants';
import Button from 'global_elements/Button';
import { ButtonVariant } from 'global_elements/Button/variants';
import { ReactComponent as UpArrow } from 'icons/mho-up-arrow-white-icon.svg';
import { ReactComponent as DownArrow } from 'icons/mho-down-arrow-white-icon.svg';
import type { TFunction } from 'i18next';
import './styles.scss';
import { UserContext } from 'context/user';
import SideNavLinkComponent from '../SideNavLink';
import { NavBarVariant } from '../NavBar/variants';
import { getSubmenuIcon } from '../lib/navIconOptions';
import { NavLinkVariant } from '../NavLinkWrapper/variants';

export type SubMenuProps = {
  isUHS: boolean;
  childItems: AnyRoute[];
  title: string;
  defaultExpanded: boolean;
  setParentExpanded: (isExpanded: boolean) => void;
  t: TFunction<'translation', 'app'>;
  navBarVariant: NavBarVariant;
};

export default function SubmenuComponent(props: SubMenuProps): JSX.Element {
  const { isNavExpanded, SetIsNavExpanded } = useContext(UserContext);
  const [isSubmenuExpanded, setIsSubmenuExpanded] = useState<boolean>(props.defaultExpanded);

  const getArrow = (): JSX.Element => (isSubmenuExpanded ? <UpArrow /> : <DownArrow />);

  const submenuClicked = (): void => {
    props.setParentExpanded(!isSubmenuExpanded);
    setIsSubmenuExpanded((prev) => !prev);

    if (!isNavExpanded) {
      SetIsNavExpanded(true);
    }
  };

  useEffect(() => {
    if (!isNavExpanded) {
      setIsSubmenuExpanded(false);
      props.setParentExpanded(false);
    }
  }, [isNavExpanded, props]);

  return (
    <FlexContainer
      display={DisplayVariant.FLEX_COL}
      align={AlignVariant.START}
      justify={JustifyVariant.START}
      extraClasses={`submenu-button-container ${props.navBarVariant === NavBarVariant.ICON ? '--icon' : ''}`}
    >
      <Button onClick={submenuClicked} variant={ButtonVariant.INVISIBLE} extraClasses={`submenu-title ${props.navBarVariant}`} testid={`Submenu-${props.title}`}>
        {props.navBarVariant === NavBarVariant.ICON ? (
          <FlexContainer display={DisplayVariant.FLEX_ROW} align={AlignVariant.START} justify={JustifyVariant.CENTER} extraClasses="submenu-button-icon-contents">
            {getSubmenuIcon(props.title)}
          </FlexContainer>
        ) : (
          <FlexContainer display={DisplayVariant.FLEX_ROW} align={AlignVariant.CENTER} justify={JustifyVariant.START} extraClasses="submenu-button-container">
            <Paragraph text={props.title} fontColor={FontColors.BACKGROUND} fontSize={FontSizes.EXTRA_LARGE} />
            {getArrow()}
          </FlexContainer>
        )}
      </Button>
      {isSubmenuExpanded
        && props.childItems.map((route: AnyRoute) => (
          <SideNavLinkComponent
            route={route}
            key={route}
            navLinkVariant={props.navBarVariant === NavBarVariant.ICON ? NavLinkVariant.ICON : NavLinkVariant.SUB}
            isUHS={Boolean(props.isUHS)}
            t={props.t}
            navBarVariant={props.navBarVariant}
          />
        ))}
    </FlexContainer>
  );
}
